(function () {
  if (window.__wdCartThresholdDynamicInit) return;
  window.__wdCartThresholdDynamicInit = true;

  var minimumOrderCents = 8000;
  var shippingThresholdCents = 20000;
  var refreshTimer = null;
  var lastRenderedTotal = null;

  function formatMoney(cents) {
    return '$' + Math.max(0, cents / 100).toFixed(2);
  }

  function getWidgets() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-wd-cart-thresholds]'));
  }

  function setHidden(element, shouldHide) {
    if (!element) return;
    element.hidden = shouldHide;
    element.style.display = shouldHide ? 'none' : '';
  }

  function ensureMinimumNotice(widget, shippingNotice) {
    var minimumNotice = widget.querySelector('.wd-cart-thresholds__notice--minimum');
    if (minimumNotice || !shippingNotice) return minimumNotice;

    minimumNotice = document.createElement('div');
    minimumNotice.className = 'wd-cart-thresholds__notice wd-cart-thresholds__notice--minimum';
    minimumNotice.setAttribute('role', 'status');
    minimumNotice.hidden = true;
    minimumNotice.style.display = 'none';

    var title = document.createElement('strong');
    title.className = 'wd-cart-thresholds__title';
    title.textContent = 'Order minimum is $80.';

    var text = document.createElement('p');
    text.className = 'wd-cart-thresholds__text';

    minimumNotice.appendChild(title);
    minimumNotice.appendChild(text);
    widget.insertBefore(minimumNotice, shippingNotice);

    return minimumNotice;
  }

  function renderWidget(widget, cart) {
    var cartTotal = Number(cart && cart.total_price) || 0;
    var shippingNotice = widget.querySelector('.wd-cart-thresholds__notice--shipping');
    var minimumNotice = ensureMinimumNotice(widget, shippingNotice);
    var minimumText = minimumNotice && minimumNotice.querySelector('.wd-cart-thresholds__text');
    var shippingText = widget.querySelector('[data-wd-shipping-message]');
    var progressFill = widget.querySelector('.wd-cart-thresholds__bar-fill');
    var shippingRemaining = Math.max(0, shippingThresholdCents - cartTotal);
    var minimumRemaining = Math.max(0, minimumOrderCents - cartTotal);
    var shouldHideWidget = !cart || !cart.item_count || cartTotal >= shippingThresholdCents;

    setHidden(widget, shouldHideWidget);
    if (shouldHideWidget) return;

    setHidden(minimumNotice, cartTotal >= minimumOrderCents);
    if (minimumText && cartTotal < minimumOrderCents) {
      minimumText.textContent = 'Add ' + formatMoney(minimumRemaining) + ' more to check out.';
    }

    setHidden(shippingNotice, false);
    widget.setAttribute('data-shipping-remaining', formatMoney(shippingRemaining));
    widget.setAttribute('data-threshold-label', formatMoney(shippingThresholdCents));

    if (shippingText) {
      shippingText.textContent = 'Add ' + formatMoney(shippingRemaining) + ' more toward the ' + formatMoney(shippingThresholdCents) + ' shipping offer.';
    }

    if (progressFill) {
      progressFill.style.setProperty('--wd-cart-threshold-progress', Math.min(100, Math.round((cartTotal / shippingThresholdCents) * 100)) + '%');
    }
  }

  function renderFromCart(cart) {
    lastRenderedTotal = Number(cart && cart.total_price) || 0;
    getWidgets().forEach(function (widget) {
      renderWidget(widget, cart);
    });
  }

  function fetchAndRender() {
    if (!getWidgets().length) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(renderFromCart)
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(fetchAndRender, delay || 150);
  }

  function scheduleSeveralRefreshes() {
    scheduleRefresh(150);
    window.setTimeout(fetchAndRender, 650);
    window.setTimeout(fetchAndRender, 1400);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleRefresh(0);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('button, a, input[type="submit"], [data-cart-remove], [data-drawer-to-open="cart-drawer"]')) {
      scheduleSeveralRefreshes();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('cart-items, #cart-drawer, form[action*="/cart"]')) {
      scheduleSeveralRefreshes();
    }
  }, true);

  document.addEventListener('cart:updated', scheduleSeveralRefreshes);
  document.addEventListener('cart:refresh', scheduleSeveralRefreshes);

  new MutationObserver(function () {
    var widgets = getWidgets();
    if (!widgets.length) return;
    if (lastRenderedTotal === null) {
      scheduleRefresh(100);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
